// QR de aprovisionamiento de UNA línea, para registrarla en el Netvoice Softphone leyéndolo
// con la cámara. Desde la tabla de líneas de la ficha del cliente.
//
// El QR lleva la CONTRASEÑA SIP en claro: quien lo fotografía registra la línea. Por eso se
// arma en el navegador (no viaja a ningún servicio de terceros) y sale del mismo endpoint de
// credenciales que la fila "Técnico", con su mismo control de roles.
//
// Formato (v1) — lo que el softphone tiene que parsear:
//   {"t":"netvoice-sip","v":1,"user":"…","pass":"…","domain":"mi.eneural.org",
//    "server":"mi.eneural.org","port":5060,"transport":"udp","name":"…","did":"593…"}
// `domain` es el realm (va en el From/To y en la autenticación); `server` es a dónde se manda
// el REGISTER. Campos desconocidos se ignoran; un `v` mayor al soportado se rechaza.
import { useState, useEffect } from "react";
import QRCode from "qrcode";
import apiv1 from "../api_v1";

export const QR_TIPO = "netvoice-sip";
export const QR_VERSION = 1;

export function payloadLinea(cred, linea) {
  return JSON.stringify({
    t: QR_TIPO,
    v: QR_VERSION,
    user: cred.sip_user,
    pass: cred.sip_password,
    domain: cred.sip_realm,
    server: cred.sip_server,
    port: Number(cred.sip_port) || 5060,
    transport: "udp",
    name: linea.alias || cred.did_number || cred.sip_user,
    did: cred.did_number || "",
  });
}

export default function QrLineaModal({ linea, onClose }) {
  const [cred, setCred] = useState(null);
  const [img, setImg] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const r = await apiv1.get(`/lines/${linea.id}/credentials`);
        if (!vivo) return;
        setCred(r.data);
        // Sin la contraseña en claro (quedó solo el hash) el QR no registraría nada.
        if (!r.data.sip_password) {
          setErr("La contraseña SIP de esta línea no es recuperable. Regenerala desde 🔧 Técnico y volvé a generar el QR.");
          return;
        }
        const url = await QRCode.toDataURL(payloadLinea(r.data, linea),
          { errorCorrectionLevel: "M", margin: 2, width: 320 });
        if (vivo) setImg(url);
      } catch (e) {
        if (!vivo) return;
        setErr(e.response?.status === 403 ? "Sin permisos para ver credenciales" :
               e.response?.status === 404 ? "La línea no tiene credenciales SIP activas" :
               "No se pudo generar el QR");
      }
    })();
    return () => { vivo = false; };
  }, [linea]);

  const archivo = `qr-linea-${cred?.did_number || linea.did_number || linea.id}.png`;

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.55)', display:'flex',
      alignItems:'center', justifyContent:'center', zIndex:1100 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background:'var(--bg-surface)', borderRadius:'var(--r)', border:'1px solid var(--border)',
        padding:24, width:400, maxWidth:'92vw', maxHeight:'90vh', overflowY:'auto', textAlign:'center' }}>
        <div style={{ fontSize:15, fontWeight:700, color:'var(--text-primary)', marginBottom:4 }}>
          QR para el Softphone
        </div>
        <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:16 }}>
          Línea <code style={{ color:'var(--brand)' }}>{linea.did_number || linea.sip_user}</code>
          {linea.alias ? ` · ${linea.alias}` : ''}
        </div>

        {!img && !err && <div style={{ fontSize:12, color:'var(--text-muted)', padding:40 }}>Generando…</div>}
        {err && <div style={{ fontSize:12, color:'var(--danger)', padding:'16px 0' }}>{err}</div>}
        {img && (
          <>
            {/* Fondo blanco fijo: en tema oscuro un QR sin margen claro no lo lee la cámara. */}
            <img src={img} alt="Código QR de registro SIP" width={260} height={260}
              style={{ background:'#fff', borderRadius:8, padding:8 }}/>
            <div style={{ fontSize:11, color:'var(--text-muted)', margin:'10px 0 0' }}>
              {cred.sip_user} @ {cred.sip_server}:{cred.sip_port}
            </div>
            <div style={{ fontSize:11, color:'var(--warning, #b7791f)', margin:'10px 0 0' }}>
              ⚠ Incluye la contraseña SIP: compartilo solo con el titular de la línea.
            </div>
          </>
        )}

        <div style={{ display:'flex', gap:8, justifyContent:'center', marginTop:18 }}>
          {img && (
            <a className="nv-btn nv-btn-sm" href={img} download={archivo}>⬇ Descargar PNG</a>
          )}
          <button className="nv-btn nv-btn-sm" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
